import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Markdown from "markdown-to-jsx";
import get from "src/lib/get";
import Container from "src/react/layout/container";
import { ContentSection } from "../styles";

const imageSizes = {
  small: 175,
  medium: 350,
  large: 500,
};

function ContentBlocks({ data = [] }) {
  return (
    !!data.length && (
      <Container>
        {data.map((contentBlock) => {
          const {
            contentBlockHeading,
            contentBlockImage,
            contentBlockImageAlign,
            contentBlockImageSize = "medium",
            contentBlockText,
          } = contentBlock.fields;
          const image = get(contentBlockImage, "fields.file", {});
          const imageTitle = get(contentBlockImage, "fields.title", "");
          const imageUrl =
            image.url && `${image.url}?fm=jpg&fl=progressive&bg=rgb:fff`;
          const imageWidthFromSize = imageSizes[contentBlockImageSize];

          return (
            <CustomContentSection
              key={contentBlock.sys.id}
              data-selector="ContentBlocks"
              align={contentBlockImageAlign}
            >
              {imageUrl && (
                <Image
                  src={`${imageUrl}&w=${imageWidthFromSize}`}
                  srcSet={`${imageUrl}&w=${imageWidthFromSize * 2} 2x`}
                  width={image.details.image.width}
                  height={image.details.image.height}
                  maxWidth={imageWidthFromSize}
                  alt={imageTitle}
                  align={contentBlockImageAlign}
                />
              )}
              <ContentWrapper>
                <h2>{contentBlockHeading}</h2>
                <Markdown>{contentBlockText}</Markdown>
              </ContentWrapper>
            </CustomContentSection>
          );
        })}
      </Container>
    )
  );
}
ContentBlocks.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        contentBlockHeading: PropTypes.string.isRequired,
        contentBlockText: PropTypes.string.isRequired,
        contentBlockImage: PropTypes.object,
        contentBlockImageAlign: PropTypes.string,
      }).isRequired,
      sys: PropTypes.object.isRequired,
    })
  ),
};

export default ContentBlocks;

const CustomContentSection = styled(ContentSection)`
  @media (min-width: 700px) {
    display: flex;
    flex-direction: ${({ align }) =>
      align === "right" ? "row-reverse" : "row"};
  }
  margin-bottom: 40px;
  h2 {
    font-size: 22px;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
`;

const Image = styled.img`
  max-width: ${({ maxWidth }) => maxWidth}px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto 20px;
  border-radius: 5px;
  align-self: center;
  @media (min-width: 700px) {
    ${({ align }) =>
      align === "right" ? "margin: 0 0 0 40px;" : "margin: 0 40px 0;"};
  }
`;

const ContentWrapper = styled.div`
  align-self: center;
`;
